import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Shield } from 'lucide-react';
export function AuthoritySection() {
  return <section className="py-20 bg-cream border-y border-gold/10" data-id="element-13">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-14">
        <FadeIn data-id="element-15">
          <Shield className="w-12 h-12 text-gold mx-auto mb-8" strokeWidth={1.5} data-id="element-16" />

          <div className="space-y-6 text-xl md:text-2xl font-serif text-brown/80 italic" data-id="element-17">
            <p data-id="element-18">Basado en psicología, cuerpo y conciencia.</p>
            <p data-id="element-19">Integración práctica, no teoría.</p>
            <p className="text-gold-dark font-bold" data-id="element-20">
              Diseñado para que lo apliques desde el primer día.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}